import {
  useGetOptionValueIngredientsQuery,
  useLinkIngredientToOptionValueMutation,
  useRemoveOptionValueIngredientMutation,
  useUpdateOptionValueIngredientMutation,
} from "@/redux/services/inventory/recipe.api";
import RecipeIngredientsManager from "./RecipeIngredientsManager";
import { usePermissions } from "@/hooks/usePermissions";

interface OptionValueIngredientsProps {
  optionValueId: string;
  restaurantId: string;
}

const OptionValueIngredients = ({
  optionValueId,
  restaurantId,
}: OptionValueIngredientsProps) => {
  // Recipes are read with inventory.view and written with inventory.manage.
  const { canManage } = usePermissions();
  const { data, isLoading } = useGetOptionValueIngredientsQuery({
    optionValueUuid: optionValueId,
  });
  const [link, { isLoading: isLinking }] =
    useLinkIngredientToOptionValueMutation();
  const [remove] = useRemoveOptionValueIngredientMutation();
  const [update, { isLoading: isUpdating }] =
    useUpdateOptionValueIngredientMutation();

  return (
    <RecipeIngredientsManager
      readOnly={!canManage("inventory")}
      restaurantId={restaurantId}
      linkedIngredients={data?.results ?? []}
      isLoading={isLoading}
      isLinking={isLinking}
      isUpdating={isUpdating}
      emptyTitle="Aucun ingrédient lié à cette option"
      emptySubtitle="Ajoutez des ingrédients pour suivre la consommation générée par cette option."
      onLink={async (payload) => {
        const res = await link({
          optionValueUuid: optionValueId,
          data: payload,
        });
        return "data" in res ? { ok: true } : { ok: false };
      }}
      onRemove={async (mapping) => {
        const res = await remove({
          optionValueUuid: optionValueId,
          mappingUuid: mapping.id,
        });
        return "error" in res ? { ok: false } : { ok: true };
      }}
      onUpdate={async (mapping, args) => {
        const res = await update({
          optionValueUuid: optionValueId,
          mappingUuid: mapping.id,
          data: args,
        });
        return "error" in res ? { ok: false } : { ok: true };
      }}
    />
  );
};

export default OptionValueIngredients;
